var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileLinkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 27,
    viewBox: "0 0 31 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.35296 1.00835C9.2807 1.00649 9.24365 1.04118 9.20661 1.07586C2.12021 2.49722 -1.49396 10.8857 1.30831 17.1942C4.55461 24.5119 13.1765 28.0479 20.8483 26.3565C28.811 24.6014 32.8783 16.866 29.9609 9.41414C26.8422 1.35133 17.183 -1.21351 9.35296 1.00835ZM28.3896 18.4967C27.188 21.6374 24.0278 23.623 20.896 24.5047C14.4128 26.3692 6.96844 23.4337 3.53641 17.7148C0.24339 12.2133 3.05631 4.05367 9.7407 2.80015C9.85001 2.76733 9.92318 2.73357 9.99635 2.69982C16.6954 0.8765 24.4933 2.71637 27.87 9.18217C29.3873 12.0365 29.5522 15.4618 28.3896 18.4967Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLinkIcon);
export default __webpack_public_path__ + "static/media/mobile-link-icon.2714b95de8c7f937d9aa859bdc0c880c.svg";
export { ForwardRef as ReactComponent };